import ITimeLeft from '../common/interfaces/ITimeLeft';

export function getUTCDate(date?: Date): Date | undefined {
    if (date === undefined) {
        return undefined;
    }

    const convertedDate = new Date(date);

    const now = new Date();
    return new Date(convertedDate.getTime() + now.getTimezoneOffset() * 60000);
}

export function getTimeLeft(dateTime?: Date): ITimeLeft {
    if (dateTime === undefined) return { hours: 0, minutes: 0, seconds: 0 };

    const now = new Date().getTime();
    const distance = new Date(dateTime).getTime() - now;

    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
    );

    return {
        hours: hours > 0 ? hours : 0,
        minutes: minutes > 0 ? minutes : 0,
        seconds: seconds > 0 ? seconds : 0,
    };
}

function differenceInDays(date: Date) {
    const differenceInMilleseconds =
        getUTCDate(new Date(Date.now()))!.getTime() - date.getTime();

    return differenceInMilleseconds / (1000 * 60 * 60 * 24);
}

export function olderThanDays(date: Date, days: number = 1): boolean {
    return differenceInDays(date) >= days;
}

export function formatDateTime(date: Date): string {
    const d = new Date(date);
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} | ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}
